var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { EqHtmlGrid } from "../widgets/eq_result_html_grid";
import { DataFilterView } from "./data_filter_view";
/**
 * The EasyQuery client-side view that represents the UI for data filtering page
 */
var HtmlDataFilterView = /** @class */ (function (_super) {
    __extends(HtmlDataFilterView, _super);
    function HtmlDataFilterView() {
        return _super.call(this) || this;
    }
    /**
    * Creates the widget that represents Grid Widget.
    * @param slot The HTMLElement to place the created widget in.
    * @returns the created Widget object.
    */
    HtmlDataFilterView.prototype.createResultGridWidget = function (element) {
        return new EqHtmlGrid(element);
    };
    /**
     * Obsolete. Left for backward compatibility.
     * Use fetchData() instead
     */
    HtmlDataFilterView.prototype.applyQueryFilter = function () {
        console.warn('applyQueryFilter is obsolete. Use fetchData instead');
        this.fetchData();
    };
    return HtmlDataFilterView;
}(DataFilterView));
export { HtmlDataFilterView };
//# sourceMappingURL=html_data_filter_view.js.map